import { render, staticRenderFns } from "./CeoExternalPeople.vue?vue&type=template&id=01a9bc0b&scoped=true&"
import script from "./CeoExternalPeople.vue?vue&type=script&lang=js&"
export * from "./CeoExternalPeople.vue?vue&type=script&lang=js&"
import style0 from "./CeoExternalPeople.vue?vue&type=style&index=0&id=01a9bc0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9bc0b",
  null
  
)

export default component.exports